import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'

import heroImg from 'assets/img/retail-property-catering-hero.jpg'
import gridImage1 from 'assets/img/retail-property-grid-1.jpeg'
import gridImage2 from 'assets/img/retail-property-grid-2.jpeg'
import gridImage3 from 'assets/img/retail-property-grid-3.jpeg'
import gridImage4 from 'assets/img/retail-property-grid-4.jpeg'
import gridImage5 from 'assets/img/retail-property-grid-5.jpeg'

export default function gridImagePage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Placemaking With Food Trucks for Retail Properties - Roaming Hunger</title>
        <meta name="og:title" content="Placemaking With Food Trucks for Retail Properties"></meta>
        <meta name="description" content="The holiday season means many things. To us, it means the grocery stores start playing “Jingle Bells”, menorahs appear in window sills, and the movie Elf is constantly on TV. Whatever you celebrate..."></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Placemaking With Food Trucks for Retail Properties"
          onButtonClick={openModal}
          description={(
            <div>
              Roaming Hunger partners with retail property owners to positively impact the value
              of your properties by growing onsite traffic and building community engagement
              through our network of over 18,000 mobile food trucks.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Increase NOI With No Cost to You
        </h2>
        <p className="font-light text-gray-900 mt-6">
          As the retail industry continues to evolve, community driven strategies and placemaking
          will create a competitive advantage to forward thinking real estate owners. Whether
          it’s diversifying foot traffic, strengthening your tenant funnel, or increasing
          specialty leasing opportunities, we’ll work as partners to reach your goals.
        </p>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Attract More Shoppers to Your Retail Centers"
          content="Create a placemaking strategy to increase community engagement, long-term tenant leases, and diversify foot traffic."
          image={gridImage1}
        />
        <OccasionPageGridRow
          heading="Maximize Your Tenant Funnel"
          content="Create long-term leasing opportunities for each property by attracting profitable local vendors."
          image={gridImage2}
          reverse
        />
      </OccasionPageGrid>

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Placemaking for Retail Property Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Placemaking for Retail Property Catering Works"
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Diversify Your Foot Traffic"
          content="Our mobile food vendors attract profitable shopper demographics, and open up marketing and branding opportunities for your tenants."
          image={gridImage3}
          reverse
        />
        <OccasionPageGridRow
          heading="No Competing Cuisines"
          content="Our diverse network of over 18,000 food trucks means you’ll never have to worry about conflicts of interest with your existing tenants."
          image={gridImage4}
        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />
      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="A No-Risk Strategy"
          content="We’ll create a successful mobile food program for you and your current tenants, then scale and optimize based on location, seasonality, day, or even hour."
          image={gridImage5}
          reverse
        />

      </OccasionPageGrid>

    </Layout>
  )
}
